import makeActionCreator from './makeActionCreator';
import {
  ADD_NEW_ACCOUNT_ADMIN,
  ADD_NEW_ACCOUNT_ADMIN_DONE,
  ADD_NEW_ACCOUNT_ADMIN_ERROR,
  ADD_NEW_ACCOUNT_ADMIN_LOADING,
  ADD_NEW_ACCOUNT_ADMIN_SUCCESS,
  FETCH_ACCOUNT_ADMIN,
  FETCH_ACCOUNT_ADMIN_DONE,
  FETCH_ACCOUNT_ADMIN_ERROR,
  FETCH_ACCOUNT_ADMIN_LOADING,
  FETCH_ACCOUNT_ADMIN_SUCCESS,
  REMOVE_ACCOUNT_ADMIN,
  REMOVE_ACCOUNT_ADMIN_DONE,
  REMOVE_ACCOUNT_ADMIN_ERROR,
  REMOVE_ACCOUNT_ADMIN_LOADING,
  REMOVE_ACCOUNT_ADMIN_SUCCESS,
  UPDATE_ACCOUNT_NAME,
  UPDATE_ACCOUNT_NAME_DONE,
  UPDATE_ACCOUNT_NAME_ERROR,
  UPDATE_ACCOUNT_NAME_LOADING,
  UPDATE_ACCOUNT_NAME_SUCCESS
} from './actionTypes';

export const fetchAccountAdmin = makeActionCreator(FETCH_ACCOUNT_ADMIN, 'tenantId');
export const fetchAccountAdminLoading = makeActionCreator(FETCH_ACCOUNT_ADMIN_LOADING);
export const fetchAccountAdminSuccess = makeActionCreator(FETCH_ACCOUNT_ADMIN_SUCCESS, 'admins');
export const fetchAccountAdminError = makeActionCreator(FETCH_ACCOUNT_ADMIN_ERROR, 'error');
export const fetchAccountAdminDone = makeActionCreator(FETCH_ACCOUNT_ADMIN_DONE);

export const updateAccountName = makeActionCreator(UPDATE_ACCOUNT_NAME, 'tenantId', 'name');
export const updateAccountNameLoading = makeActionCreator(UPDATE_ACCOUNT_NAME_LOADING);
export const updateAccountNameSuccess = makeActionCreator(UPDATE_ACCOUNT_NAME_SUCCESS, 'tenant');
export const updateAccountNameError = makeActionCreator(UPDATE_ACCOUNT_NAME_ERROR, 'error');
export const updateAccountNameDone = makeActionCreator(UPDATE_ACCOUNT_NAME_DONE);

export const addNewAccountAdmin = makeActionCreator(ADD_NEW_ACCOUNT_ADMIN, 'tenantId', 'emails');
export const addNewAccountAdminLoading = makeActionCreator(ADD_NEW_ACCOUNT_ADMIN_LOADING);
export const addNewAccountAdminSuccess = makeActionCreator(ADD_NEW_ACCOUNT_ADMIN_SUCCESS, 'admins');
export const addNewAccountAdminError = makeActionCreator(ADD_NEW_ACCOUNT_ADMIN_ERROR, 'error');
export const addNewAccountAdminDone = makeActionCreator(ADD_NEW_ACCOUNT_ADMIN_DONE);

export const removeAccountAdmin = makeActionCreator(REMOVE_ACCOUNT_ADMIN, 'tenantId', 'idOrEmail');
export const removeAccountAdminLoading = makeActionCreator(REMOVE_ACCOUNT_ADMIN_LOADING);
export const removeAccountAdminSuccess = makeActionCreator(REMOVE_ACCOUNT_ADMIN_SUCCESS, 'admins');
export const removeAccountAdminError = makeActionCreator(REMOVE_ACCOUNT_ADMIN_ERROR, 'error');
export const removeAccountAdminDone = makeActionCreator(REMOVE_ACCOUNT_ADMIN_DONE);

